module.exports = __webpack_public_path__ + "9ebbbb4ff37b0f126d583bd4df569cd4.pdf";